import * as React from 'react';
import Popover from '@mui/material/Popover';
import clsx from 'clsx';

export default function BasicPopover({
  action,
  isOpen,
  anchorOrigin,
  transformOrigin,
  handlePopoverClick,
  handlePopoverClose,
  content,
  disabled,
  disableRefClick,
  enableHover,
  className,
}) {
  const [dynamicAnchorOrigin, setDynamicAnchorOrigin] =
    React.useState(anchorOrigin);
  const [dynamicTransformOrigin, setDynamicTransformOrigin] =
    React.useState(transformOrigin);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [hovering, setHovering] = React.useState(false);
  const [timer, setTimer] = React.useState(null);

  React.useEffect(() => {
    if (hovering) {
      const newTimer2 = setTimeout(() => {
        setAnchorEl(hovering);
      }, 1200);
      const newTimer = setTimeout(() => {
        handlePopoverClick && handlePopoverClick(hovering);
      }, 800);
      setTimer(newTimer);
      setTimer(newTimer2);
    }

    return () => clearTimeout(timer);
  }, [hovering]);

  const handleMouseEnter = (event) => {
    setHovering(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setHovering(false);
    clearTimeout(timer);
  };

  const handleClick = (event) => {
    if (disableRefClick) {
      handlePopoverClick && handlePopoverClick(event.currentTarget);
    } else {
      const rect = event.currentTarget.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const estimatedPopoverHeight = 220;
      const bottomSafeInset = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--safe-area-inset-bottom'
        ) || '0'
      );

      const willOverflowBottom =
        rect.bottom + estimatedPopoverHeight > windowHeight - bottomSafeInset;

      if (willOverflowBottom) {
        setDynamicAnchorOrigin({
          vertical: 'top',
          horizontal: 'right',
        });
        setDynamicTransformOrigin({
          vertical: 'bottom',
          horizontal: 'right',
        });
      } else {
        setDynamicAnchorOrigin(
          anchorOrigin || {
            vertical: 'bottom',
            horizontal: 'right',
          }
        );
        setDynamicTransformOrigin(
          transformOrigin || {
            vertical: 'top',
            horizontal: 'right',
          }
        );
      }

      setAnchorEl(event.currentTarget);
      handlePopoverClick && handlePopoverClick(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    handlePopoverClose && handlePopoverClose(null);
  };

  React.useEffect(() => {
    if (!isOpen) {
      handleClose();
    }
  }, [isOpen]);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <span
        style={{ zIndex: 1, height: 'fit-content' }}
        aria-describedby={id}
        onClick={disabled ? () => {} : handleClick}
        onMouseEnter={enableHover ? handleMouseEnter : () => {}}
        onMouseLeave={enableHover ? handleMouseLeave : () => {}}
      >
        {action}
      </span>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={dynamicAnchorOrigin}
        transformOrigin={dynamicTransformOrigin}
        className={clsx(className)}
      >
        {content}
      </Popover>
    </>
  );
}
